import React from 'react';
import { Subtract } from 'utility-types';
export interface InjectedPublishedConnectionSpaceServiceInjectorProps {
}

export interface PublishedConnectionSpaceServiceInjectorProps {
  readonly publishedConnectionId: string;
}

export function withPublishedConnectionSpaceServiceInjector<P extends InjectedPublishedConnectionSpaceServiceInjectorProps>(
  Component: React.ComponentType<P>
) {
  return function PublishedConnectionSpaceServiceInjector(
    props: Subtract<P, InjectedPublishedConnectionSpaceServiceInjectorProps> & PublishedConnectionSpaceServiceInjectorProps
  ) {

    return <Component
      {...props as unknown as P}
    />;
  };
}
